module.exports = __webpack_public_path__ + "static/media/screens-ft.6e05ef66.jpg";